import { connect } from 'react-redux'

const commonFields = {
  grupoConteudo: {
    required: false
  },
  publicoAlvo: {
    required: false
  },
  buscaPalavrasChave: {
    required: false
  },
  buscaPeso: {
    conditionalRequired(obj) {
      const errorMessage = 'Este campo é obrigatório.'
      if ((obj['buscaPalavrasChave'] || []).length) {
        return {
          required: true,
          errorMessage
        }
      } else {
        return {
          required: false,
          errorMessage
        }
      }
    }
  }
}
export default commonFields



// WEBPACK FOOTER //
// ./src/contentSchema/commonFields.js